<div
    provideParentForm
    class="tls-fingerprint-match"
>
    <match-wrapper
        label="{{ label }}"
        objectType="{{ objectType }}"
        fieldName="{{ fieldName }}"
        (onRemoveMatch)="removeMatch()"
    >
        <enum-radio-buttons
            enum="MatchOperation"
            name="match-operation-{{ fieldName }}"
            [(ngModel)]="editable.config.match_operation"
            [noMarginTop]="true"
        ></enum-radio-buttons>

        <div class="tls-fingerprint-match__container">
            <string-group-or-custom-value
                [(stringGroupRefs)]="editable.config.string_group_refs"
                [(customValues)]="editable.config.fingerprints"
                [areStringGroupOrCustomFieldsRequired]="true"
                id="tls-fingerprint-match"
                [noMarginTop]="true"
                label="{{ l10nKeys.fingerprintLabel | vtranslate }}"
            ></string-group-or-custom-value>
        </div>
    </match-wrapper>
</div>
